// Catálogo único de "fuentes de opciones" para permisos tipo "seleccion".
//
//
// IMPORTANTE: `coleccion` es el nombre REAL de la colección en Mongo
// (ej. el modelo "Proveedor" usa la colección "proveedors"). El populate del
// backend añade `empresaId` automáticamente, por eso no va en filtroExtra.

export const FUENTES_OPCIONES = [
  {
    value: "bancos",
    label: "Bancos",
    fuenteOpciones: {
      coleccion: "bancos",
      campoNombre: "nombre",
      filtroExtra: { caja: false, estado: 1 },
    },
  },
  {
    value: "cajasChicas",
    label: "Cajas chicas",
    fuenteOpciones: {
      coleccion: "bancos",
      campoNombre: "nombre",
      filtroExtra: { caja: true, estado: 1 },
    },
  },
  {
    value: "proveedores",
    label: "Proveedores",
    fuenteOpciones: {
      coleccion: "proveedors",
      campoNombre: "nombre",
      filtroExtra: { estado: 1 },
      formato: "proveedor",
    },
  },
  {
    value: "cajas",
    label: "Cajas POS",
    fuenteOpciones: {
      coleccion: "cajas",
      campoNombre: "nombre",
      filtroExtra: { estado: 1 },
    },
  },
  {
    value: "almacenes",
    label: "Almacenes",
    fuenteOpciones: {
      coleccion: "almacenes",
      campoNombre: "nombre",
      filtroExtra: {},
    },
  },
  {
    value: "sucursales",
    label: "Sucursales",
    fuenteOpciones: {
      coleccion: "sucursales",
      campoNombre: "nombre",
      filtroExtra: {},
    },
  },
  {
    value: "empresas",
    label: "Empresas",
    fuenteOpciones: {
      coleccion: "empresas",
      campoNombre: "nombre",
      filtroExtra: {},
    },
  },
];

// Compara dos filtros (objetos planos) por igualdad de pares clave/valor.
const mismoFiltro = (a, b) => {
  const fa = a || {};
  const fb = b || {};
  const claves = new Set([...Object.keys(fa), ...Object.keys(fb)]);
  for (const k of claves) {
    if (fa[k] !== fb[k]) return false;
  }
  return true;
};

// key -> objeto fuenteOpciones (copia, para no compartir referencias).
export const fuenteOpcionesDesdeKey = (key) => {
  const item = FUENTES_OPCIONES.find((f) => f.value === key);
  return item ? { ...item.fuenteOpciones } : undefined;
};

// objeto fuenteOpciones -> key. Distingue Bancos vs Cajas chicas (misma
// coleccion) comparando además el filtroExtra.
export const keyDesdeFuenteOpciones = (obj) => {
  if (!obj || !obj.coleccion) return undefined;
  const item = FUENTES_OPCIONES.find(
    (f) =>
      f.fuenteOpciones.coleccion === obj.coleccion &&
      mismoFiltro(f.fuenteOpciones.filtroExtra, obj.filtroExtra)
  );
  return item ? item.value : undefined;
};

// objeto fuenteOpciones -> etiqueta legible (fallback al nombre de coleccion).
export const labelDesdeFuenteOpciones = (obj) => {
  const key = keyDesdeFuenteOpciones(obj);
  const item = FUENTES_OPCIONES.find((f) => f.value === key);
  return item ? item.label : obj?.coleccion || "";
};
